import { render, staticRenderFns } from "./CommentsCell.vue?vue&type=template&id=433a5ac3&scoped=true&"
import script from "./CommentsCell.vue?vue&type=script&lang=js&"
export * from "./CommentsCell.vue?vue&type=script&lang=js&"
import style0 from "./CommentsCell.vue?vue&type=style&index=0&id=433a5ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a5ac3",
  null
  
)

export default component.exports